import React, { useEffect, useState } from "react";
import logo from "../../assets/PNG/KonnectxLogoWhite.png";
import { Link, NavLink } from "react-router-dom";
import "./header.scss";


const Header = ({ handleClickScroll }) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <nav id="nav-header">
        <Link to="/" class="logo">
          <img src={logo} alt="Logo Image" />
        </Link>
        <div
          className={`hamburger ${isOpen ? "toggle" : ""}`}
          onClick={handleToggle}
        >
          <div class="bars1"></div>
          <div class="bars2"></div>
          <div class="bars3"></div>
        </div>
        <ul onClick={handleToggle} className={`nav-links ${isOpen ? "open" : ""}`}>
          <li className={`fade1 ${isOpen ? "fade-in" : ""}`}><NavLink activeClassName="active" to="/" >Home</NavLink></li>
          <li className={`fade1 ${isOpen ? "fade-in" : ""}`}><NavLink activeClassName="active" to="/about-us">About us</NavLink></li>
          <li className={`fade1 ${isOpen ? "fade-in" : ""}`}><NavLink activeClassName="active" to="/packages">Packages</NavLink></li>
          <li className={`fade1 ${isOpen ? "fade-in" : ""}`}><NavLink activeClassName="active" to="/services">Services</NavLink></li>
          <li className={`fade1 ${isOpen ? "fade-in" : ""}`}><NavLink activeClassName="active" to="/blogs">Blog</NavLink></li>
          {/* {
            !window?.location?.pathname?.includes("/blogs") && 
          <li onClick={handleClickScroll} className={`fade1 contact ${isOpen ? "fade-in" : ""}`}><a>Contact Us</a></li>
          } */}
          <li onClick={handleClickScroll} className={`fade1 contact ${isOpen ? "fade-in" : ""}`}><a>Contact Us</a></li>

        </ul>
        <a class="login-button" href="tel:+18663454585">(866) 345-4585</a>
      </nav>
    </>
  );
};

export default Header;
